import { render, staticRenderFns } from "./Parkings.vue?vue&type=template&id=9bf657f0&scoped=true&"
import script from "./Parkings.vue?vue&type=script&lang=js&"
export * from "./Parkings.vue?vue&type=script&lang=js&"
import style0 from "./Parkings.vue?vue&type=style&index=0&id=9bf657f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf657f0",
  null
  
)

export default component.exports